import { getMissingWorklog } from "../services/apiWorklog";
import { useMappedQuery } from "./queryUtils";

export function useWorklogMissing() {
  return useMappedQuery({
    queryKey: ["worklog-missing"],
    queryFn: getMissingWorklog,
    dataKey: "worklog",
  });
}
